<template>
  <div class="tw-flex tw-items-center">
    <input
      :id="id"
      class="form-radio tw-h-4 tw-w-4 tw-border-gray-300 tw-text-primary focus:tw-ring-primary"
      type="radio"
      :value="value"
      :name="name"
      @change="updateInput"
      :checked="isChecked"
      :disabled="disabled"
    />
    <label class="tw-ml-3 tw-block tw-text-sm tw-text-gray-700" :for="id">
      <slot />
    </label>
  </div>
</template>

<script>
import { uniqueId } from "lodash";

export default {
  model: {
    prop: "modelValue",
    event: "change",
  },
  props: {
    value: { type: [String, Number] },
    name: { type: String },
    modelValue: { default: "" },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      id: uniqueId("radio-"),
    };
  },
  computed: {
    isChecked() {
      return this.modelValue === this.value;
    },
  },
  methods: {
    updateInput() {
      this.$emit("change", this.value);
    },
  },
};
</script>
